import React from "react";

interface SVGComponentProps {
  scale?: number;
}

export const WavePatternSVG: React.FC<SVGComponentProps> = ({ scale = 1 }) => (
  <svg
    width="105"
    height="90"
    viewBox="0 0 105 90"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `scale(${scale})` }}
  >
    <path
      d="M14 20 Q 19 17, 24 20 T 34 20 T 44 20 T 54 20 T 64 20 T 74 20 T 84 20"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
    <path
      d="M9 40 Q 14 37, 19 40 T 29 40 T 39 40 T 49 40 T 59 40 T 69 40 T 79 40 T 89 40 T 94 40"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
    <path
      d="M19 60 Q 24 57, 29 60 T 39 60 T 49 60 T 59 60 T 69 60 T 79 60"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
    <path
      d="M12 80 Q 17 77, 22 80 T 32 80 T 42 80 T 52 80 T 62 80 T 72 80 T 82 80 T 91 80"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
  </svg>
);
